import React from "react";

/**
 * Single-select category chips for the template picker — an "All" chip the
 * picker opens on, then one per template type present in the list, each
 * labelled with how many templates carry it.
 *
 * Clicking the active chip is a no-op rather than a deselect: All is already
 * the un-narrowed state, so deselecting would only leave the list in a state no
 * chip describes. `value` of `null` deliberately lights nothing up — that is
 * what the picker passes while a search is running, whose results span every
 * category including All.
 */
const TemplateCategoryChips = ({ options = [], value, onChange = () => {} }) => {
  if (!options.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {options.map(option => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => !isActive && onChange(option.value)}
            className={`inline-flex items-center px-3 py-[3px] rounded-[14px] border border-solid cursor-pointer text-[13px] leading-[22px] transition-colors ${
              isActive
                ? "border-[#1677ff] bg-[#e6f4ff] text-[#1677ff] font-medium"
                : "border-[#d9d9d9] bg-white text-black/[0.65] font-normal hover:border-[#4096ff] hover:text-[#4096ff]"
            }`}
          >
            {option.label} ({option.count})
          </button>
        );
      })}
    </div>
  );
};

export default TemplateCategoryChips;
